import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/works";

export default function Testimonials() {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Voices"
        title="参赛者和读者怎么说"
        desc="作品集会持续收录来自参赛者与读者的真实反馈，这些留言也构成了大赛的一部分。"
      />
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {testimonials.map((t) => (
          <figure key={t.name} className="flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-lg">
              <i className="ri-double-quotes-l" />
            </span>
            <blockquote className="mt-4 text-sm text-foreground-700 leading-relaxed flex-1">{t.text}</blockquote>
            <figcaption className="mt-5 pt-4 border-t border-background-300 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                <i className="ri-user-3-line" />
              </span>
              <span>
                <span className="block font-heading text-sm font-bold text-foreground-950">{t.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-500">{t.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}